import PDFPageViewer from './PDFPageViewer';
import SupportEmail from "../components/SupportEmail";

const Terms = () => {
  const pdfUrl = "https://omegavoid.com/documents/Omega_Void_Terms.pdf";

  return (
    <>
      <div className="about-container" style={{ marginTop: '30px' }}>
        <h1>Terms of Service</h1>

        <div style={{ textAlign: 'left', maxWidth: '800px', width: '90%', marginBottom: '20px' }}>
          <div className="terms-pdf-section" style={{ marginTop: '2rem', marginBottom: '2rem' }}>
            <PDFPageViewer pdfUrl={pdfUrl} loadingText="Loading Terms of Service document..." />
          </div>
        </div>
      </div>
      <SupportEmail />
    </>
  );
};

export default Terms;
